import {CreateActiveAction} from "../../Traits/ActiveItem";
import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Customers
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customersGetRequest = simpleAction(TYPES.CUSTOMERS_GET_REQUEST);

/**
 * Request customers success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customersGetSuccess = simpleAction(TYPES.CUSTOMERS_GET_SUCCESS);

/**
 * Request customers error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customersGetError = simpleAction(TYPES.CUSTOMERS_GET_FAIL);

/**
 * Request customers error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customersGetDone = simpleAction(TYPES.CUSTOMERS_GET_DONE);

/**
 * Request Customer
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerLoadRequest = simpleAction(TYPES.CUSTOMER_LOAD_REQUEST);

/**
 * Request Customer success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerLoadSuccess = simpleAction(TYPES.CUSTOMER_LOAD_SUCCESS);

/**
 * Request Customer error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerLoadError = simpleAction(TYPES.CUSTOMER_LOAD_FAIL);

/**
 * Create Customer
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerCreateRequest = simpleAction(TYPES.CUSTOMER_CREATE_REQUEST);

/**
 * Create Customer Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerCreateSuccess = simpleAction(TYPES.CUSTOMER_CREATE_SUCCESS);

/**
 * Create Customer Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerCreateError = simpleAction(TYPES.CUSTOMER_CREATE_FAIL);

/**
 * Update Customer
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerUpdateRequest = simpleAction(TYPES.CUSTOMER_UPDATE_REQUEST);

/**
 * Update Customer Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerUpdateSuccess = simpleAction(TYPES.CUSTOMER_UPDATE_SUCCESS);

/**
 * Update Customer Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const customerUpdateError = simpleAction(TYPES.CUSTOMER_UPDATE_FAIL);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}}
 */
export const customerActiveRequest = simpleAction(TYPES.ACTIVE_REQUEST);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}}
 */
export const customerActiveClean = simpleAction(TYPES.ACTIVE_CLEAN);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}}
 */
export const customerActiveSuccess = simpleAction(TYPES.ACTIVE_SUCCESS);

/**
 *
 * @type {function(payload:T): {type: string, payload: T}}}
 */
export const customerActiveError = simpleAction(TYPES.ACTIVE_FAIL);

/**
 * Create a function to get active customer
 */
export const getActiveCustomer = CreateActiveAction("Customers", {
    dispatchMethod: "customerActiveRequest",
    stateProperty: "customer",
    propsProperty: "customer",
    routeParam: "customer",
});
